import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

export type AppLogoVariant = 'full' | 'mark' | 'navbar';

interface Props {
  variant?: AppLogoVariant;
  height?: number | string;
  to?: string;
  alt?: string;
  sx?: SxProps<Theme>;
}

const SRC: Record<AppLogoVariant, string> = {
  navbar: '/images/logo/logo-navbar.png',
  full: '/images/logo/logo-full.png',
  mark: '/images/logo/icon-mark-192.png',
};

export default function AppLogo({
  variant = 'full',
  height,
  to,
  alt = 'The Sports Hub',
  sx,
}: Props) {
  const isNavbar = variant === 'navbar';

  const img = (
    <Box
      component="img"
      src={SRC[variant]}
      alt={alt}
      sx={{
        height: isNavbar ? 'auto' : (height ?? 40),
        width: 'auto',
        maxHeight: isNavbar ? '100%' : (height ?? 40),
        display: 'block',
        objectFit: 'contain',
        objectPosition: 'left center',
        borderRadius: isNavbar ? 1.5 : 0,
        ...sx,
      }}
    />
  );

  if (to === undefined) return img;

  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: isNavbar ? '100%' : 'auto',
        textDecoration: 'none',
        flexShrink: 0,
        lineHeight: 0,
      }}
    >
      {img}
    </Box>
  );
}
